(() => {
  const scope = document.getElementById('MainContent');
  if (!scope) return;

  let queued = false;
  let initialize = !new URLSearchParams(window.location.search).has('variant');
  const requested = new WeakSet();
  scope.addEventListener('click', (event) => {
    if (event.isTrusted && event.target.closest('.tee-radio')) initialize = false;
  }, true);
  const select = (input) => {
    const label = input?.parentElement.querySelector('label');
    if (!label || requested.has(input)) return;
    requested.add(input);
    label.click();
  };
  const arrange = () => {
    queued = false;
    const word = scope.querySelector('#tee-field--layer-582902, #tee-field--layer-542271, #tee-field--layer-179221, #tee-field--layer-588407');
    const anchor = word || scope.querySelector('#tee-field--layer-763519');
    const picker = scope.querySelector('.tee-available-products');
    const form = anchor?.closest('.tee-customization-form');
    if (!form || !picker || anchor.closest('.tee-campaign') !== picker.closest('.tee-campaign')) return;
    if (anchor.nextElementSibling !== picker) {
      observer.disconnect();
      anchor.after(picker);
      observer.observe(scope, { childList: true, subtree: true });
    }
    const paper = picker.querySelector('#teeinblue-available-prod-297917');
    const sizes = scope.querySelector('.tee-campaign .tee-option--size .tee-option-inner');
    const a4 = sizes?.querySelector('input[value="A4 (21 × 29,7 cm)"]');
    if (a4 && sizes.firstElementChild !== a4.parentElement) sizes.prepend(a4.parentElement);
    if (!initialize || !paper) return;
    if (!paper.closest('.tee-radio').classList.contains('active')) {
      select(paper);
      return;
    }
    if (!a4) return;
    if (!a4.checked) {
      select(a4);
      return;
    }
    initialize = false;
  };
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(arrange);
  });
  observer.observe(scope, { childList: true, subtree: true });
  arrange();
})();
